document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-description-preview]').forEach((wrapper) => {
    const content = wrapper.querySelector('[data-description-content]');
    const toggle = wrapper.querySelector('[data-description-toggle]');
    if (!(content instanceof HTMLElement) || !(toggle instanceof HTMLElement)) return;

    const moreLabel = toggle.querySelector('[data-label-more]');
    const lessLabel = toggle.querySelector('[data-label-less]');
    if (!(moreLabel instanceof HTMLElement) || !(lessLabel instanceof HTMLElement)) return;

    content.classList.add('product-description-preview__content--clamped');

    // Only reveal the toggle if the description actually overflows the
    // clamped height — short descriptions stay expanded with no button.
    requestAnimationFrame(() => {
      if (content.scrollHeight > content.clientHeight + 1) {
        toggle.hidden = false;
      } else {
        content.classList.remove('product-description-preview__content--clamped');
      }
    });

    toggle.addEventListener('click', () => {
      const isClamped = content.classList.toggle('product-description-preview__content--clamped');
      moreLabel.hidden = !isClamped;
      lessLabel.hidden = isClamped;
    });
  });
});
